import React from 'react'

import './styles.scss'

export const AdMediaExamples = () => (
  <section className="video-examples section-block">
    <div className="video-examples__header">Video:</div>
  </section>
)
